module.exports = __webpack_public_path__ + "img/Welcome.6ab49860.jpg";